import $ from 'jquery';

export default function() {

  $(function() {
    initialize_impactStats();
  });


  function initialize_impactStats() {
    const $impactStats = $('.impact-stats');
    const supportsIntersectionObserver = !!window.IntersectionObserver;

    // A three-second count-up is motion, and the global reduced-motion reset is
    // CSS — it can't reach a JS timer. The markup already holds the real figure,
    // so opting out just means leaving it alone.
    const prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      return;
    }

    if (supportsIntersectionObserver && $impactStats.length) {
      const elements = document.querySelectorAll('[data-animateCount]');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startCountUpAnimation(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -100px 0px'
      });


      const startCountUpAnimation = function(countableEl) {
        const $countableEl = $(countableEl);
        const finalValue = $countableEl.attr('data-countUpTo');
        const animationDurationS = 3;

        const countTo = parseInt(String(finalValue).replace(/,/g, ''), 10);

        // Nothing to count up to — "Nearly 40", "1.5M", a percentage. The markup
        // already carries the real figure, so leave it be. This used to fall
        // back to 0, and animateCountUp() returns early on 0, which pinned the
        // stat at "0" permanently.
        if (isNaN(countTo)) {
          return;
        }

        animateCountUp($countableEl, countTo, animationDurationS, finalValue);
      };


      elements.forEach(observedEl => {
        observer.observe(observedEl);
      });
    }


    function animateCountUp(countingEl, countToNum, duration, endValue) {

      if (countToNum === 0) {
        return;
      }

      let increment = 1
      let current = 0;
      let convertedDuration = duration * 1000;
      let stepTimer = parseFloat(convertedDuration / countToNum);


      if (stepTimer <= 10) {
        let adjustedDuration = duration * 100;
        stepTimer = 10;
        increment = parseInt(countToNum / adjustedDuration) + 1;
      }


      stepTimer = Math.floor(stepTimer);
      const $countingObj = $(countingEl);

      const timer = setInterval(function() {
        current += increment;

        $countingObj.html(Number(current).toLocaleString());

        if (current >= countToNum) {
          $countingObj.html(endValue);
          clearInterval(timer);
        }
      }, stepTimer);
    }
  }

}
